import React, { useCallback, useEffect, useState } from "react";
import { Eye, EyeOff, LoaderCircle, Plus, Trash2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TeamTestimonials({ code }) {
  const [items, setItems] = useState(null);
  const [quote, setQuote] = useState("");
  const [author, setAuthor] = useState("");
  const [saving, setSaving] = useState(false);
  const headers = { "Content-Type": "application/json", "X-Team-Code": code };

  const load = useCallback(async () => {
    const response = await fetch(`${API}/team/testimonials`, { headers: { "X-Team-Code": code } });
    if (response.ok) setItems((await response.json()).testimonials);
  }, [code]);

  useEffect(() => { load(); }, [load]);

  const add = async (event) => {
    event.preventDefault();
    if (!quote.trim() || !author.trim()) return;
    setSaving(true);
    try {
      const response = await fetch(`${API}/team/testimonials`, { method: "POST", headers, body: JSON.stringify({ quote: quote.trim(), author: author.trim() }) });
      if (response.ok) {
        setQuote("");
        setAuthor("");
        load();
      }
    } finally {
      setSaving(false);
    }
  };
  const toggle = async (item) => {
    await fetch(`${API}/team/testimonials/${item.id}`, { method: "PATCH", headers, body: JSON.stringify({ visible: !item.visible }) });
    load();
  };
  const remove = async (item) => {
    await fetch(`${API}/team/testimonials/${item.id}`, { method: "DELETE", headers: { "X-Team-Code": code } });
    load();
  };

  return (
    <div className="testimonials-manager" data-testid="testimonials-manager">
      <form className="testimonial-add" onSubmit={add}>
        <span className="card-eyebrow">Add a Google review</span>
        <textarea className="input-control textarea-control" rows="3" value={quote} onChange={(event) => setQuote(event.target.value)} placeholder="Paste the review text…" data-testid="testimonial-quote-input" />
        <div className="testimonial-add-row">
          <input className="input-control" value={author} onChange={(event) => setAuthor(event.target.value)} placeholder="Reviewer first name" data-testid="testimonial-author-input" />
          <button type="submit" className="button button-primary" disabled={saving || !quote.trim() || !author.trim()} data-testid="testimonial-add-button">{saving ? <LoaderCircle className="spin" size={14} /> : <Plus size={14} />} Add to site</button>
        </div>
      </form>
      {items === null ? (
        <div className="team-empty"><LoaderCircle className="spin" size={18} /> Loading testimonials…</div>
      ) : (
        <div className="testimonial-rows">
          {items.map((item) => (
            <div className={`testimonial-row${item.visible ? "" : " is-hidden"}`} key={item.id} data-testid={`testimonial-row-${item.id}`}>
              <div className="testimonial-row-text">
                <span className="testimonial-stars">★★★★★ · {item.author} · {item.event}</span>
                <p>{item.quote}</p>
              </div>
              <div className="testimonial-row-actions">
                <button type="button" className="text-button" onClick={() => toggle(item)} title={item.visible ? "Hide from site" : "Show on site"} data-testid={`testimonial-toggle-${item.id}`}>{item.visible ? <Eye size={15} /> : <EyeOff size={15} />} {item.visible ? "Live" : "Hidden"}</button>
                <button type="button" className="text-button testimonial-delete" onClick={() => remove(item)} data-testid={`testimonial-delete-${item.id}`}><Trash2 size={14} /> Remove</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
